import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Style from "./SubmitDeliverRequest.module.css";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import RequestPerview from "./components/RequestPerview/RequestPerview";
import PeykDiscountCode from "./components/DiscountCode/PeykDiscountCode";
import { itemListData } from "./components/ItemCategory/itemListData";
import { requestDeliveryApi } from "../../Api/DeliveryServices";
import { errorToast, succToast } from "../../Toast/Toast";

const SubmitDeliverRequest = () => {
  const location = useLocation();
  const history = useHistory();
  const [loadingState,setLoadingState]=useState(false)
  useEffect(() => {
    if (!location.state) history.push("/newdeliveryrequest");
  }, []);

  const sendRequestHandler=()=>{
    setLoadingState(true)
    const userData=location.state
    const categorySelect=itemListData.find(item=>item.key===parseInt(userData.categoryItemKey))
    const info={
      routes:[userData.origin.location,userData.destination.location,userData.secondDestination&&userData.destination2.location].filter(Boolean),
      routes_description:[userData.senderInfo.senderDescription??"",userData.resiverInfo.resiverDescription??"",userData.secondDestination && userData.resiver2Info?.resiver2Description ? userData.resiver2Info.resiver2Description : ""],
      description:[userData.origin.address,userData.destination.address,userData.secondDestination&&userData.destination2.address].filter(Boolean),
      names:[userData.senderInfo.senderName,userData.resiverInfo.resiverName,userData.secondDestination && userData.resiver2Info?.resiver2Name ].filter(Boolean),
      phones:[userData.senderInfo.senderPhone,userData.resiverInfo.resiverPhone,userData.secondDestination && userData.resiver2Info?.resiver2Phone ].filter(Boolean),
      category:categorySelect.lable,
      product_description:userData.productDescription,
      vehicle_type:'motorcycle'
    }
    requestDeliveryApi(info,(succ,res)=>{
      if(succ){
        if(res.status===1){
          succToast('درخواست شما ثبت شد!')
          setTimeout(() => {
            setLoadingState(false)
            history.push('./deliveryrequest')
          }, 500);
        }else{
          setLoadingState(false)
          errorToast(res.message)
        }
      }else{
        console.error(res)
        setLoadingState(false)
      }
    })
  }
  return (
    <div className={Style.pageHolder}>
      <BurgerMenuTitle title="پیک" />
        <RequestPerview data={location.state}/>
        {/* <StatickMapImage/> */}
        <PeykDiscountCode/>
        <button className={Style.SubmitButtonHolder} onClick={sendRequestHandler} disabled={loadingState}>
        {loadingState?"لطفا صبر کنید":"درخواست پیک"}
          </button>
    </div>
  );
};

export default SubmitDeliverRequest;
